const wowApp = require('angular').module('wowApp.shop');

//Service
wowApp.service('ContentOverlayService', [require('./content-overlay-service')]);

//Directive
wowApp.directive('wowContentOverlay', ['ContentOverlayService', require('./content-overlay-directive')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/contentoverlay/index.js
 **/